import { RootState } from "../store";

export const selectDefect = (state: RootState) => state.defect;

export const selectDefects = (state: RootState) => state.defect.data;

export const selectDefectToEdit = (state: RootState) => state.defect.toEdit;

export const selectDefectToEditImages = (state: RootState) => state.defect.toEditImages;

export const selectDefectCodes = (state: RootState) => state.defect.defectCodes;

export const selectDefectCodesToEdit = (state: RootState) => state.defect.toEditDefectCodes;

export const selectDefectsToDelete = (state: RootState) => state.defect.toDelete;

export const selectDefectDeleteDialog = (state: RootState) => state.defect.showDeleteSelected;

export const selectDefectFailed = (state: RootState) => state.defect.failed;

export const selectFilteredDefects = (state: RootState) => state.defect.filteredDefects;

export const selectDefectCodeCategories = (state: RootState) => state.defect.defectCategories;

export const selectRegimeMappings = (state: RootState) => state.defect.regimeMappings;
